export const getConfig = () => {
  const env = import.meta.env.VITE_ENVIRONMENT as string;

  // This should be same but it's splitted for local testing
  const defaultAudience = 'https://api.staging.cloud.brighte.com.au/v2/graphql';
  const defaultUrl = 'https://api.staging.cloud.brighte.com.au/v2/graphql';

  const apiUrlMap: Record<string, string> = {
    uat: 'https://api.uat.cloud.brighte.com.au/v2/graphql',
    prod: 'https://api.brighte.com.au/v2/graphql',
  };

  return {
    audience: apiUrlMap[env] ?? defaultAudience,
    url: apiUrlMap[env] ?? defaultUrl,
  };
};
